import React from 'react';
// import './EdTechPlatformHeader.css';

const EdTechPlatformHeader = () => (
  <div className="product-header-block sub-etp">
    <div className="product-header-content">
      <span className="badge-cloud">AWS Cloud Distributed</span>
      <h2>ETP Platform</h2>
      <p>Distributed Learning Infrastructure & Multi-Modal Orchestration</p>
    </div>
  </div>
);

export default EdTechPlatformHeader;
